import { ErrorMessage, useField, useFormikContext } from 'formik';
import { CustomErrorMessage } from '@src/design-system/error-message';
import { DocumentUpload } from 'iconsax-react';
import {
  Upload,
  UploadArea,
  UploadError,
  UploadTrigger,
} from '@src/design-system/upload';
import { useUploadMedia } from '@features/placements/services/upload-media';
import { LoaderCircle } from 'lucide-react';
import { TiptapEditor } from '@shared/components/reusables/tiptap-editor';

export const NoteFileField = () => {
  const [fieldProps, , fieldHelpers] = useField('note');
  const { setFieldValue, values } = useFormikContext<{ attachments: File[] }>();
  const { mutateAsync: uploadMedia, isPending } = useUploadMedia();

  const handleFileUpload = async (file: File) => {
    try {
      const response = await uploadMedia({ file });
      const uploadedFile = response;
      setFieldValue('attachments', [
        ...(values.attachments || []),
        uploadedFile,
      ]);
    } catch (error) {
      console.error('File upload failed:', error);
    }
  };

  return (
    <div className='mb-6'>
      <label className='text-sm font-medium text-gray-800'>Add Note</label>
      <div className='mt-1 border focus-within:border-active-border overflow-hidden focus-within:ring-[3px] transition-all focus-within:ring-ring/10 bg-primary-30 border-pale-border rounded-lg has-data-error:border-destructive has-data-error:ring-[3px] has-data-error:ring-destructive/15 has-data-error:focus-within:border-destructive has-data-error:focus-within:ring-destructive/15'>
        <TiptapEditor
          value={fieldProps.value}
          onChange={(content) => fieldHelpers.setValue(content)}
          contentClassName='border-0'
          enableMention
        />

        <Upload
          maxSize={1024 * 1024 * 1}
          onFileChange={handleFileUpload}
        >
          <div>
            <UploadArea className='w-full'>
              {isPending ? (
                <div className='cursor-pointer h-auto flex justify-end p-3'>
                  <LoaderCircle
                    className='animate-spin'
                    size={25}
                  />
                </div>
              ) : (
                <UploadTrigger className='cursor-pointer h-auto flex justify-end pb-3 pr-3 pt-1'>
                  <DocumentUpload
                    size={43}
                    color='#584777'
                    className='cursor-pointer bg-primary-100 rounded-md p-1.5'
                    strokeWidth={1}
                  />
                </UploadTrigger>
              )}
            </UploadArea>
            <UploadError />
          </div>
        </Upload>
      </div>
      <div className='flex flex-col gap-1'>
        <ErrorMessage
          name='note'
          component={CustomErrorMessage}
        />

        <ErrorMessage
          name={'file'}
          component={CustomErrorMessage}
        />
      </div>
    </div>
  );
};
